import React from "react";
import "./App.scss";
import NavBar from "./NavBar/NavBar";
import Hero from "./Hero/Hero";
import Numbers from "./Numbers/Numbers";

function App() {
  return (
    <div className="App">
      {/* <NavBar /> */}
      <Hero />
      <Numbers />
    </div>
  );
}

export default App;
